import {CommonModule, Location} from '@angular/common';
import {Component, inject} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatToolbarModule} from '@angular/material/toolbar';
import {RouterLink} from '@angular/router';
import {Store} from '@ngxs/store';
import {AppState} from '../../states';

@Component({
    selector: 'evencel-page-404',
    standalone: true,
    imports: [MatButtonModule, MatToolbarModule, CommonModule, RouterLink],
    templateUrl: './page-404.component.html',
    styleUrl: './page-404.component.scss',
})
export class Page404Component {
    location = inject(Location);
    store = inject(Store);
    darkMode$ = this.store.select(AppState.darkMode);
}
